import * as React from "react";
import AdminTable from "src/core/ui/admin-table";
import { ExpenseInformation } from "../../../typings";

interface IExpensesTableProps {
    expenses: ExpenseInformation[];
}

interface IExpensesTableState {}

class ExpensesTable extends React.Component<IExpensesTableProps, IExpensesTableState> {
    columns: any[] = [
        {
            label: "USER ID",
            flex: 1,
        },
        {
            label: "DATE",
            flex: 3,
        },
        {
            label: "ACTION",
            flex: 3,
        },
        {
            label: "ONE",
            flex: 1,
        },
        {
            label: "USD",
            flex: 1,
        },
        {
            label: "GBP",
            flex: 1,
        },
        {
            label: "EUR",
            flex: 1,
        },
    ];

    formatDate(date: Date) {
        return date.getDate() + "-" + (date.getMonth() + 1).toString() + "-" + date.getFullYear();
    }

    render(): JSX.Element {
        const { expenses } = this.props;

        const expenseRows: JSX.Element[][] = expenses.map((e) => [
            <div>{e.user}</div>,
            <div>{this.formatDate(new Date(e.createdAt))}</div>,
            <div>{e.action}</div>,
            <div>{e.fee.one}</div>,
            <div>{e.fee.usd.toFixed(2)}</div>,
            <div>{e.fee.gbp.toFixed(2)}</div>,
            <div>{e.fee.eur.toFixed(2)}</div>,
        ]);

        return <AdminTable columns={this.columns} rows={expenseRows} />;
    }
}

export default ExpensesTable;



// WEBPACK FOOTER //
// ./src/components/admin_panel/tables/expenses-table.tsx